module.exports = __webpack_public_path__ + "img/zwjh.667b1cef.png";